import { FC, PropsWithChildren, MouseEventHandler } from "react";

interface OfficeButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  size?: "sm" | "md" | "lg";
  variant?:
  | "primary"
  | "secondary"
  | "tertiary"
  | "danger"
  | "warning"
  | "success";
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
}

const OfficeButton: FC<PropsWithChildren<OfficeButtonProps>> = ({
  children,
  onClick,
  disabled,
  loading,
  size = "md",
  variant = "primary",
  type = "button",
}) => {
  const sizeClasses = {
    sm: "text-sm leading-4 font-medium px-3 py-1.5",
    md: "text-base leading-6 font-medium px-4 py-2",
    lg: "text-lg leading-6 font-medium px-5 py-3",
  };

  const variantClasses = {
    primary: "bg-green-700 hover:bg-green-800 focus:ring-green-500",
    secondary: "bg-teal-600 hover:bg-teal-700 focus:ring-teal-500",
    tertiary: "bg-gray-600 hover:bg-gray-700 focus:ring-gray-500",
    danger: "bg-red-600 hover:bg-red-700 focus:ring-red-500",
    warning: "bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500",
    success: "bg-green-600 hover:bg-green-700 focus:ring-green-500",
  };

  const baseClasses =
    "inline-flex items-center rounded-md border mx-1 border-transparent disabled:cursor-not-allowed text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2";

  const classes = `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]}`;

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={classes}
    >
      {loading ? "Please wait..." : children}
    </button>
  );
};

export default OfficeButton;
